module.exports = __webpack_public_path__ + "static/media/favicon-96x96.b85a9e57.png";